// extracted by mini-css-extract-plugin
export default {"app":"Routes_app__l4M2P"};